// extracted by mini-css-extract-plugin
module.exports = {"progress":"HeroProgress--progress--SV9e_","progress__line":"HeroProgress--progress__line--3DjXs","placeholderAnim":"HeroProgress--placeholderAnim--3QSeS"};